import IconCard from "../../components/iconCard/IconCard";
import { faPoundSign } from "@fortawesome/free-solid-svg-icons";
import { faChartUser } from "@fortawesome/pro-solid-svg-icons";
import { useSession, LogoutReason } from "../Auth/hooks/useSession";
import AuthLogoutMessage from "../Auth/components/AuthLogoutMessage";

const Reports = () => {
	const { reason } = useSession();

	if (reason !== LogoutReason.None) {
		return (<AuthLogoutMessage reason={reason} />);
	}

	return (
		<div className="reports">
			<h1>Reports</h1>
			<p>View all your reports from here.</p>

			<div className="mt-4 twoColGrid">
				{/*Hidden until fixed*/}
				{/*<IconCard title="Billing Report" icon={faPoundSign} link="/billing-report">*/}
				{/*	Get a detailed month by month report of your sales.*/}
				{/*</IconCard>*/}
				<IconCard title="Usage Report" icon={faChartUser} link="/usage-report">
					Get a detailed month by month report of user's usage satistics.
				</IconCard>
			</div>
		</div>
	)
};

export default Reports